import { Dispatch } from 'redux';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import {
    AppState,
    Booking,
    BookingLeg,
    Itinerary as ItineraryModel
} from 'acscp/store';
import {
    ItineraryRequest,
    RequestClass
} from 'acscp/api/requests';
import { FetchRequest } from 'acscp/actions';
import React from 'react';
import { RequestStateProps } from 'acscp/components/common/helpers/requestStateProps';
import { LoadingIndicator } from 'acscp/components/common/loadingIndicator';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { getBookingItinerary } from 'acscp/store/helpers/getBookingItinerary';
import { ItineraryLegs } from './itineraryLegs';
import { LegacyItinerary } from './legacyItinerary';

interface ItineraryStateProps {
    bookingLegs: BookingLeg[] | undefined;
    itinerary: ItineraryModel | null;
    itineraryRequestState: RequestStateProps;
}

interface ItineraryOwnProps {
    bookingDetails: Booking;
}

interface ItineraryDispatchProps {
    fetchItinerary: () => void;
}

export class ItineraryPresentational
    extends PresentationComponentBase<ItineraryOwnProps,
    ItineraryStateProps,
    ItineraryDispatchProps, {}> {

    componentDidMount(): void {
        this.props.fetchItinerary();
    }

    render(): JSX.Element | null {
        const { itinerary, bookingLegs, bookingDetails } = this.props;
        if (this.props.itineraryRequestState.isLoading) {
            return <LoadingIndicator />;
        } else if (!!itinerary && !!bookingLegs && !!itinerary.itineraryLegs && itinerary.itineraryLegs.length !== 0) {
            return <ItineraryLegs itinerary={itinerary} bookingLegs={bookingLegs} bookingDetails={bookingDetails} />;
        } else if (!!itinerary && !!bookingLegs) {
            return (
                <LegacyItinerary itinerary={itinerary} bookingLegs={bookingLegs} bookingDetails={bookingDetails} />
            );
        } else {
            // TODO: ACSCP-276 improve error handling.
            return null;
        }
    }
}

function mapStateToProps(
    state: AppState, ownProps: ItineraryOwnProps, getRequestError: (request: RequestClass<any>) => RequestStateProps
): ItineraryStateProps {
    const booking = ownProps.bookingDetails;
    return {
        itinerary: getBookingItinerary(state.itineraries, booking.id),
        bookingLegs: booking.legs,
        itineraryRequestState: getRequestError(ItineraryRequest),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: ItineraryOwnProps): ItineraryDispatchProps {
    return {
        fetchItinerary: () => dispatch(new FetchRequest(new ItineraryRequest(ownProps.bookingDetails.id))),
    };
}

export const Itinerary = connectWithRequests(mapStateToProps, mapDispatchToProps)(ItineraryPresentational);
